<template>
	<div class="ld-tooltip" @mouseover="createTooltip">
		<div class="ld-tooltip--target" :class="{ show: isOpen }">
			<slot name="target" />
		</div>

		<div class="ld-tooltip--content">
			<div class="ld-tooltip--scroll">
				<slot name="content" />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "LdTooltip",
	data() {
		return {
			isOpen: false,
			delay: null,
			delayTime: 200
		};
	},
	props: {
		parent: {
			default: "body"
		},
		top: {
			type: Number,
			default: 0,
		}
	},
	computed: {
		tooltipParent() {
			if (typeof this.parent === "string") {
				return document.querySelector(this.parent);
			} else if (typeof this.parent === "object") {
				return this.parent;
			}

			return null;
		}
	},
	methods: {
		isDescendant(parent, child) {
			let node = child.parentNode;
			while (node != null) {
				if (node == parent) {
					return true;
				}
				node = node.parentNode;
			}
			return false;
		},
		repositionTooltip($tooltipParent, tooltipCoordinates) {
			const $tooltipElement = document.querySelector(
				".ld-tooltip--element"
			);

			if ($tooltipElement && $tooltipParent) {
				const parentCoordinates = $tooltipParent.getBoundingClientRect();

				const parentOffsetLeft = parentCoordinates.left;
				const parentOffsetRight = parentCoordinates.right;

				const parentOffsetTop = parentCoordinates.top;
				const parentOffsetBottom = parentCoordinates.bottom;

				const tooltipElementCoordinates = $tooltipElement.getBoundingClientRect();

				const tooltipOffsetLeft = tooltipElementCoordinates.left;
				const tooltipOffsetWidth = tooltipElementCoordinates.width;
				const tooltipOffsetRight = tooltipElementCoordinates.right;

				const tooltipOffsetTop = tooltipElementCoordinates.top;
				const tooltipOffsetBottom = tooltipElementCoordinates.bottom;

				let transformX = 0;
				let transformY = 0;

				if (tooltipOffsetLeft < parentOffsetLeft) {
					const translateX = parentOffsetLeft - tooltipOffsetLeft;
					transformX = `${translateX}px`;
				} else if (
					tooltipOffsetRight > parentOffsetRight ||
					tooltipOffsetLeft - tooltipOffsetWidth > parentOffsetLeft
				) {
					transformX = `calc(-100% - ${tooltipCoordinates.width +
						15}px)`;
				}

				if (tooltipOffsetTop < parentOffsetTop) {
					const translateY = parentOffsetTop - tooltipOffsetTop;
					transformY = `${translateY + this.top}px`;
				} else if (tooltipOffsetBottom > parentOffsetBottom) {
					transformY = `calc(-100% - ${tooltipCoordinates.height +
						10 + this.top}px)`;
				} else {
					transformY = `${this.top}px`;
				}

				$tooltipElement.style.transform = `translate(${transformX}, ${transformY})`;
			}
		},
		removeDelay() {
			if (this.delay) {
				clearTimeout(this.delay);
			}
		},
		createTooltip(event) {
			const $this = this;
			const tooltip = event.target;
			const tooltipContent = tooltip.querySelector(
				".ld-tooltip--content"
			);

			if (!tooltipContent) {
				return null;
			}

			let $tooltipElement = document.querySelector(
				".ld-tooltip--element"
			);

			if ($tooltipElement) {
				return null;
			}

			const $tooltip = document.createElement("div");
			const $buttonClipboard = document.createElement("button");

			$buttonClipboard.onclick = function() {
				let $elementCopy = tooltipContent.querySelector("p");
				const $inputForClipboard = document.createElement("input");

				if (!$elementCopy) {
					$elementCopy = tooltipContent.querySelector("div");
				}

				if (!$elementCopy) {
					return null;
				}

				$inputForClipboard.value = $elementCopy.innerText;
				$inputForClipboard.classList.add("clipboard-text");
				$tooltip.appendChild($inputForClipboard);

				const $clipboardText = $tooltip.querySelector(
					".clipboard-text"
				);

				$this.clipboard($clipboardText);
			};
			$buttonClipboard.classList.add("clipboard");
			$buttonClipboard.innerHTML =
				'<i class="vs-icon feather icon-copy"></i>';

			const tooltipCoordinates = event.target.getBoundingClientRect();
			const positionX = tooltipCoordinates.x + 20;
			const positionY = tooltipCoordinates.y + 5;

			$tooltip.style.top = positionY + "px";
			$tooltip.style.left = positionX + "px";

			$tooltip.classList.add("ld-tooltip--element");

			$tooltip.innerHTML = tooltipContent.innerHTML;

			$tooltip.appendChild($buttonClipboard);

			function listenerRemoveTooltip(event) {
				if (
					event.target &&
					event.target != tooltip &&
					event.target != $tooltip &&
					!$this.isDescendant($tooltip, event.target)
				) {
					$this.removeDelay();
					document
						.querySelector("body")
						.removeEventListener(
							"mouseover",
							listenerRemoveTooltip
						);
					$tooltip.remove();
					$this.isOpen = false;
				}
			}

			document
				.querySelector("body")
				.addEventListener("mouseover", listenerRemoveTooltip);

			this.delay = setTimeout(() => {
				document.querySelector("body").appendChild($tooltip);

				$this.isOpen = true;

				let $tooltipParent = this.tooltipParent;

				if ($tooltipParent) {
					this.repositionTooltip($tooltipParent, tooltipCoordinates);
				}
			}, this.delayTime);
		},
		clipboard(element) {
			if (
				element.setSelectionRange &&
				typeof element.setSelectionRange === "function"
			) {
				element.setSelectionRange(0, 99999); /*For mobile devices*/
			}

			if (element.select && typeof element.select === "function") {
				element.select();
			}

			document.execCommand("copy");
			element.remove();
		}
	}
};
</script>

<style lang="scss">
.ld-tooltip {
	position: absolute;
	right: 10px;
	top: 50%;
	transform: translateY(-50%);
	z-index: 1;
	font-family: "Montserrat", Helvetica, Arial, sans-serif;
	cursor: pointer;

	&:hover {
		z-index: 2;
	}

	.ld-tooltip--target {
		pointer-events: none;
	}

	.ld-tooltip--content {
		position: absolute;
		pointer-events: none;
		top: 0;
		left: 0;
		opacity: 0;
	}
}

.clipboard {
	position: absolute;
	top: 0;
	left: 0;
	padding: 5px;
	transform: translate(-25%, -25%);
	border: none;
	border-radius: 3px;
	background: rgb(146, 146, 146);
	color: #fff;
	box-shadow: 0 1px 1px rgba($color: #000000, $alpha: 0.3);
	cursor: pointer;

	&:after {
		content: "copiado";
		opacity: 0;
		position: absolute;
		color: #28c76f;
		margin-left: 10px;
	}

	&:active {
		background: rgb(245, 245, 245) !important;
		box-shadow: none;
		color: #28c76f;

		&:after {
			position: relative;
			opacity: 1;
		}
	}

	@keyframes clipboardCopied {
		0% {
			opacity: 0;
		}
		50% {
			opacity: 1;
		}
		100% {
			opacity: 0;
		}
	}
}

.ld-tooltip--element {
	position: absolute;
	max-width: 250px;
	padding: 10px 25px;
	margin: 10px;
	border-radius: 6px;
	background: rgb(146, 146, 146);
	color: #fff;
	text-align: left;
	font-size: 12px !important;
	z-index: 9999999999;
	box-sizing: border-box;
	opacity: 0;
	animation: fadein 300ms ease forwards;

	.ld-tooltip--scroll {
		max-height: 200px;
		overflow-x: hidden;
		overflow-y: auto;
	}

	& .clipboard-text {
		position: absolute;
		opacity: 0;
		z-index: -1;
		pointer-events: none;
	}

	& p {
		width: max-content;
		max-width: 200px;
		white-space: normal !important;
		word-break: break-word;
		padding: 10px;
	}

	&::after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		transform: translate(-15px, -15px);
		width: calc(100% + 30px);
		height: calc(100% + 30px);
		background: transparent;
		z-index: -1;
	}

	.vs-avatar--con-img {
		background: #fff !important;
	}

	.avatar-table.no-image {
		background: #c3c3c3 !important;
	}

	.con-vs-avatar {
		width: 40px;
		min-width: 40px;
		height: 40px;
		min-height: 40px;
	}
}

@keyframes fadein {
	0% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
</style>
